import React from 'react';
import {useFormikContext} from 'formik';
import {TextField} from '@mui/material';
import Card from '@mui/material/Card';

export default function ConservationEntryThree() {
  const {values, setFieldValue} = useFormikContext();
  return (
    <div>
      <Card className={'box-shadow'} sx={{p: 4, paddingBottom: 5}}>
        <TextField variant={'outlined'} size={'small'} fullWidth
               label={
                 <div>
                   <span style={{color: 'red'}}>*</span>
                   Incoming Date
                 </div>
               }
               type={'date'}
               value={values?.incoming_date || ''}
               onChange={(e) => setFieldValue('incoming_date', e.target.value)}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth
               label={
                 <div>
                   <span style={{color: 'red'}}>*</span>
                   Condition Assessment
                 </div>
               }
               value={values?.condition_assessment || ''}
               onChange={(e) => setFieldValue('condition_assessment', e.target.value)}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth
               label={
                 <div>
                   <span style={{color: 'red'}}>*</span>
                   Treatment Plan
                 </div>
               }
               value={values?.treatment_plan || ''}
               onChange={(e) => setFieldValue('treatment_plan', e.target.value)}
               sx={{mt: 1.5}}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>

        <TextField variant={'outlined'} size={'small'} fullWidth
               label={'Completion date'} disabled
               value={values?.completion_date || ''}
               sx={{mt: 1.5}} type={'date'}
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
        <TextField variant={'outlined'} size={'small'} fullWidth label={'Condition Assessment'}
               value={values?.condition_assessment_after || ''}
               sx={{mt: 1.5}} disabled
               InputLabelProps={{
                 style: {fontSize: 14, color: '#929191'},
                 shrink: true
               }}/>
      </Card>
    </div>
  );
}